export interface ContactItem {
    datasource?: ContactDatasources;
    data?: string;
    saveLocation?: string;
    dataType?: AdditionalContactDataTypes;
}

export enum ContactDatasources {
    ContextValue = "Context",
    Rule = "Rule",
    LoggedInUser = "LoggedInUser"
}

export enum AdditionalContactDataTypes {
    None = 0,
    Organization = 1 << 0,
}